/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'yes' }, { id: 'sometimes' }, { id: 'curious' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-women-wonder"
      progress={5}
      field="hairstyleWomenWonder"
      setter="setHairstyleWomenWonder"
      ns="hairstyleWomenWonder"
      options={OPTIONS}
      imageName="hairstyleWomenWonder"
    />
  );
}

export default Page;
